"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenHistoryList = void 0;
var TokenHistoryList = /** @class */ (function (_super) {
    __extends(TokenHistoryList, _super);
    function TokenHistoryList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getFormattedData = function () {
            var list = new TokenHistoryList();
            if (_this.length > 0) {
                _this.forEach(function (tokenHistory) {
                    var ticket = tokenHistory.ticketEntry;
                    if (ticket.bookNumber && ticket.ticketNumber) {
                        tokenHistory.displayTicketNumber = ticket.gameNumber + "-" + ticket.bookNumber + "-" + ticket.ticketNumber + "-" + ticket.validationCode;
                    }
                    else if (ticket.entryCode) {
                        var pattern = '#####-#####-#####-#####-#####';
                        var entryCode_1 = !!ticket.entryCode ? ticket.entryCode : '';
                        var i_1 = 0;
                        tokenHistory.displayTicketNumber = pattern.replace(/#/g, function () { return entryCode_1[i_1++]; });
                    }
                    list.push(tokenHistory);
                });
            }
            return list;
        };
        return _this;
    }
    return TokenHistoryList;
}(Array));
exports.TokenHistoryList = TokenHistoryList;
//# sourceMappingURL=TokenHistoryList.js.map